import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, BriefcaseIcon, MonitorIcon, HeartPulseIcon, ShieldCheckIcon, BrainIcon, BookOpenIcon, SettingsIcon, LibraryIcon } from 'lucide-react';
import { DegreeCategory } from '../data/degrees';
const iconMap: Record<string, React.ElementType> = {
  BriefcaseIcon,
  MonitorIcon,
  HeartPulseIcon,
  ShieldCheckIcon,
  BrainIcon,
  BookOpenIcon,
  SettingsIcon,
  LibraryIcon
};
interface DegreeCardProps {
  category: DegreeCategory;
}
export function DegreeCard({
  category
}: DegreeCardProps) {
  const IconComponent = iconMap[category.icon] || BookOpenIcon;
  return <Link to={`/degrees/${category.id}`} className="group flex bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md hover:border-navy/30 transition-all duration-200 flex-col justify-start" data-id="element-154" data-mp="17a4oybq13eo4">
      <div className="flex items-center justify-between mb-4" data-id="element-155" data-mp="394dghsye8otb">
        <div className="p-3 bg-light rounded-lg text-navy group-hover:bg-navy group-hover:text-white transition-colors duration-200" data-id="element-156" data-mp="3447scmrc1kfz">
          <IconComponent className="w-6 h-6" data-id="element-157" data-mp="1ua0pysjy9k6n" />
        </div>
        <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded-full" style={{
        color: "#FAFBFE",
        backgroundColor: "#FF9F04"
      }} data-id="element-158" data-mp="1zc9jpr4ncq9t">
          {category.programCount}+ Programs
        </span>
      </div>

      <h3 className="text-lg font-bold text-navy mb-2 group-hover:text-crimson transition-colors duration-200" style={{
      color: "#0F4FB0"
    }} data-id="element-159" data-mp="284tak5ep5qk3">
        {category.name}
      </h3>

      <p className="text-sm text-gray-600 mb-4 flex-grow" data-id="element-160" data-mp="2i0ej6me9tp2t">
        {category.description}
      </p>

      <div className="flex items-center text-sm font-semibold text-navy group-hover:text-crimson transition-colors duration-200 mt-auto" style={{
      color: "#5FA0EE"
    }} data-id="element-161" data-mp="2n23wk8oyueu2">
        Explore Degrees
        <ChevronRightIcon className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform duration-200" data-id="element-162" data-mp="snt65vsq3cm6" />
      </div>
    </Link>;
}